import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import format from 'date-fns/format';
// import { getMilliSecondsTimestamp } from 'utils/dateUtils';
import s from './LiveblogHeader.scss';
import SponsorLogo from '../SponsoredByLogo/SponsoredBy';
// import TimesPointHeaderWidget from '../../../../articleshow_v2/components/desktop/TimesPointHeaderWidget';
import SocialWidget from '../../../../articleshow_v2/components/common/SocialWidget/SocialWidget';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';
import Synopsis from '../../../../articleshow_v2/components/common/Synopsis';

class LiveblogHeader extends React.Component {
  constructor(props) {
    super(props);
    this.informationRef = React.createRef();
    this.state = {
      // moreClick: false,
      showSocialWidget: false,
    };
  }

  // stateforInitial() {
  //   const { information } = this.props;
  //   this.setState({ moreClick: true });
  //   if (information.length > 200) {
  //     if (
  //       this.informationRef &&
  //       this.informationRef.current &&
  //       this.informationRef.current.classList
  //     ) {
  //       this.informationRef.current.classList.remove(s.readmoreHeight);
  //     }
  //   }
  // }

  componentDidMount() {
    // this.stateforInitial();
  }

  renderLBTimeText = (lustr, seodate) => (
    <div className={s.LB_time_text}>
      <span>THE TIMES OF INDIA | </span>
      {`${lustr} IST`}
      <time dateTime={seodate} />
      <meta content={seodate} />
    </div>
  );
  showSocialShareWidget = () => {
    this.setState({ showSocialWidget: true });
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'social_share',
      category: 'liveblog_sticky',
    });
  };
  hideSocialShareWidget = () => {
    this.setState({ showSocialWidget: false });
  };
  render() {
    const {
      title,
      information,
      lastupd,
      isSportsCricketLB,
      matchStatus,
      isNonSportsLiveblog,
      isWapView,
      sponsorLead,
      sponsorLogoUrl,
      sponsorCtaUrl,
      headerLeftAlign,
    } = this.props;

    /*
  ***********************************Check why this logic was in use************************************
  const lastUpdated =
    props.timestampSource === 'cms' &&
    typeof seoData === 'object' &&
    typeof seoData.data === 'object' &&
    seoData.data.cmsTimestamp
      ? parseInt(seoData.data.cmsTimestamp, 10)
      : Math.max(
          parseInt(seoData.data.cmsTimestamp, 10) || 0,
          timelineData.lastupd * 1000 || 0,
        );
  **************************************************************************************************
  */

    const date = new Date(lastupd);
    const timestamp2 =
      lastupd + date.getTimezoneOffset() * 60 * 1000 + 330 * 60 * 1000;
    const lastUpdatedStr = format(timestamp2, 'MMM DD, YYYY, HH:mm:ss');
    const seoDate = format(lastupd, 'YYYY-MM-DDTHH:mm:ss+05:30');

    const isLiveblogActive = () => Date.now() - lastupd < 1 * 60 * 60 * 1000;
    const isLiveblogCompleted = () =>
      (matchStatus &&
        matchStatus.matchStatus &&
        matchStatus.matchStatus.toLowerCase() === 'match ended') ||
      false;

    /******* ***** This function for Description Read more and less ****************/
    // const readMoreLengthLimit = 200;
    const informationWithoutMarkup = information.replace(/<\/?[^>]+(>|$)/g, '');
    // const splitVal = informationWithoutMarkup.substr(0, readMoreLengthLimit);
    // const moreClicked = () => {
    //   if (this.state.moreClick) {
    //     this.setState({ moreClick: false });
    //     this.informationRef.current.classList.remove(s.readmoreHeight);
    //   } else {
    //     this.setState({ moreClick: true });
    //   }
    // };

    const readMoreLess = text => {
      // eslint-disable-next-line no-unused-vars
      const characterLength = text.length;
      return (
        <span
          className={`${s.descriptionTxt} `}
          dangerouslySetInnerHTML={{ __html: information }}
        />
      );
    };

    /******* ***** This function for Description Read more and less End ****************/

    return (
      <div
        className={`${s.liveblog_title_head} ${(isSportsCricketLB ||
          (isNonSportsLiveblog && !isWapView)) &&
          s.cricketlb} ${isNonSportsLiveblog &&
          !isWapView &&
          s.nonsportlb} ${(headerLeftAlign || isNonSportsLiveblog) &&
          isWapView &&
          s.leftalign}`}
        data-scrollga="scroll#scroll_starts"
      >
        <div className={s.byline_action}>
          <div
            className={`${(isSportsCricketLB ||
              (isNonSportsLiveblog && !isWapView)) &&
              s.cricketlb_top}`}
          >
            {isLiveblogActive() &&
              !isNonSportsLiveblog && (
                <div className={s.liveBlinker}>
                  <i />LIVE NOW
                </div>
              )}
            {!isWapView &&
              !isLiveblogActive() &&
              isLiveblogCompleted() && (
                <div className={s.completedFlag}>COMPLETED</div>
              )}
            {isSportsCricketLB || (isNonSportsLiveblog && !isWapView)
              ? this.renderLBTimeText(lastUpdatedStr, seoDate)
              : null}
            {/* {isSportsCricketLB || (isNonSportsLiveblog && !isWapView) ? (
            // <div className={s.social}>{this.props.renderSocialShare()}</div>
          ) : null} */}
          </div>
          {isSportsCricketLB || (isNonSportsLiveblog && !isWapView) ? (
            <React.Fragment>
              <div className={s.articleAction_wrapper}>
                <div
                  data-socialshare={this.props.msid}
                  ref={this.timespointRef}
                  className="tp_widget_as"
                >
                  {/* <TimesPointHeaderWidget
                    msid={this.props.msid}
                    title={this.props.title}
                    url={this.props.url || this.props.wu}
                    wu={this.props.url}
                    isParent
                    via={this.props.via}
                    textRequired={false}
                    tpShow
                    linkeDin
                    isWapView={false}
                    gaCategory={this.props.gaCategory}
                    gaAction="click"
                    gaIndex="atfShare_"
                    isSmallicon
                    isLiveBlog
                  /> */}
                </div>
                <div
                  className={`${s.timelineshare} icon_share_wrap`}
                  // onClick={isWapView && socialWidgetToggle}
                  onMouseEnter={this.showSocialShareWidget}
                  onMouseLeave={this.hideSocialShareWidget}
                >
                  <div className={`${s.icon_share}`}>
                    <i
                      className={`${s.shareicon} ${
                        this.state.showSocialWidget ? s.active : ''
                      }`}
                    />
                    <span>Share</span>
                  </div>
                  {this.state.showSocialWidget && (
                    <SocialWidget
                      msid={this.props.msid}
                      isParent={this.props.id === this.props.parentMsid}
                      url={this.props.url || this.props.wu}
                      title={this.props.title}
                      className={s.icon_hover_social}
                      isWapView={false}
                      isSmallicon
                      openSidebar={this.openSidebar}
                      isLiveBlog
                      // commentsCount={this.props.commentsCount}
                      wu={this.props.url}
                      via={this.props.via}
                      isTablet={this.props.isTablet}
                      type="ATF"
                      gaCategory={this.props.gaCategory}
                      gaAction="click"
                      gaIndex="atfShare_"
                      textRequired={false}
                      linkeDin
                    />
                  )}
                </div>
                <div className={`${s.gnews} ${s.gnews_top}`}>
                  <Link
                    isEtimes
                    href={
                      this.props.isEtimes
                        ? 'https://news.google.com/publications/CAAqBwgKMKrsugswt4fSAw'
                        : 'https://news.google.com/publications/CAAqBwgKMM6y_Qowwu70Ag'
                    }
                    target="_blank"
                    onClick={() => {
                      analyticsWrapper('ga4', {
                        event: 'user_click',
                        type: 'follow_google_news',
                        category: 'liveblog_sticky',
                      });
                    }}
                  >
                    Follow us <i />
                  </Link>
                </div>
              </div>
            </React.Fragment>
          ) : null}
        </div>

        {isNonSportsLiveblog &&
          (isLiveblogActive() || (sponsorLead && sponsorLogoUrl)) && (
            <div className={s.blinkerandsponsor}>
              {isLiveblogActive() && (
                <div className={s.liveBlinker}>
                  <i />LIVE NOW
                </div>
              )}
              {sponsorLead &&
                sponsorLogoUrl && (
                  <SponsorLogo
                    sponsorLead={sponsorLead}
                    sponsorLogoUrl={sponsorLogoUrl}
                    sponsorCtaUrl={sponsorCtaUrl}
                    cssClass={s.lbSponsorHead}
                  />
                )}
            </div>
          )}
        {this.props.liveblogName && (
          <div className={s.liveblogname}>
            <span>{this.props.liveblogName}</span>
          </div>
        )}
        <h1>{title}</h1>
        {/* {informationWithoutMarkup && readMoreLess(informationWithoutMarkup)} */}
        {information && (
          <div className="art_synopsis lbg_synopsis">
            <Synopsis synopsis={information} />
          </div>
        )}
        {!(isSportsCricketLB || (isNonSportsLiveblog && !isWapView))
          ? this.renderLBTimeText(lastUpdatedStr, seoDate)
          : null}
      </div>
    );
  }
}

LiveblogHeader.propTypes = {
  information: PropTypes.string,
  lastupd: PropTypes.string,
  title: PropTypes.string.isRequired,
  isSportsCricketLB: PropTypes.bool,
  //renderSocialShare: PropTypes.func,
  matchStatus: PropTypes.shape({
    matchStatus: PropTypes.string,
    currentInning: PropTypes.string,
  }),
  isWapView: PropTypes.bool,
  isNonSportsLiveblog: PropTypes.bool,
  sponsorLead: PropTypes.string,
  sponsorLogoUrl: PropTypes.string,
  sponsorCtaUrl: PropTypes.string,
  liveblogName: PropTypes.string,
  headerLeftAlign: PropTypes.string,
  isEtimes: PropTypes.bool,
  gaCategory: PropTypes.string,
  url: PropTypes.string,
  via: PropTypes.string,
  msid: PropTypes.string,
};

LiveblogHeader.defaultProps = {
  information: '',
  lastupd: '',
  isSportsCricketLB: false,
  //renderSocialShare: () => null,
  matchStatus: {
    matchStatus: '',
    currentInning: 'First',
  },
  isWapView: true,
  isNonSportsLiveblog: false,
  sponsorLead: '',
  sponsorLogoUrl: '',
  sponsorCtaUrl: '',
  liveblogName: '',
  headerLeftAlign: false,
  isEtimes: false,
  gaCategory: '',
  url: '',
  via: '',
  msid: '',
};

export default LiveblogHeader;
